import Hotkeys from './Hotkeys'

export function registerEvents(editor) {
    // Register Events
    Hotkeys(editor);
}